var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardContain"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.localTitle))]),_c('div',{staticClass:"body corner"},[_c('div',{style:({width: '100%', height: _vm.height}),attrs:{"id":_vm.rowTitle+'_'+_vm.index}})])])}
var staticRenderFns = []

export { render, staticRenderFns }